import { Component, DestroyRef, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, BreadcrumbComponent],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  readonly isSignInPage = signal(false);

  private readonly destroyRef = inject(DestroyRef);

  constructor(private authService: AuthService, private router: Router) {
    this.updateSignInPage(this.router.url);

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((event) => this.updateSignInPage(event.urlAfterRedirects));
  }

  logOut() {
    this.authService.logout();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  private updateSignInPage(url: string): void {
    this.isSignInPage.set(url.split('?')[0].split('#')[0] === '/signin');
  }
}
